import VueRouter from "vue-router";
import store from "@/state/store";
const routes = [
  {
    path: "/login",
    name: "login",
    redirect: "/signin",
  },
  {
    path: "/signin",
    name: "signin",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/signup",
    name: "signup",
    component: () => import("../views/SignupView.vue"),
  },
  {
    path: "/invitation",
    name: "invitation",
    component: () => import("../views/InvitationView.vue"),
  },
  {
    path: "/verify-email/:id",
    name: "verifyEmail",
    component: () => import("../views/VerifyEmailView.vue"),
  },
  {
    path: "/reset-password",
    name: "requestResetPassword",
    component: () => import("../views/RequestResetPasswordView.vue"),
  },
  {
    path: "/reset-password/:id",
    name: "resetPassword",
    component: () => import("../views/ResetPasswordView.vue"),
  },
  {
    path: "/create-org",
    name: "createOrganization",
    component: () => import("../views/CreateOrganizationView.vue"),
  },
  {
    path: "/",
    component: () => import("../layouts/portalLayout.vue"),
    redirect: "/",
    beforeEnter(routeTo, routeFrom, next) {
      if (!store.getters["auth/token"]) {
        return next({ name: "login" });
      }

      if (!routeTo.query.view) {
        const query = { ...routeTo.query, view: "o" };
        return next({
          path: routeTo.path,
          query,
          hash: routeTo.hash,
          params: routeTo.params,
          name: routeTo.name,
        });
      }

      if (
        (routeTo.query.view === "p" && routeTo.query.p === "") ||
        routeTo.query.o === ""
      ) {
        return next({
          query: { view: "o" },
          hash: routeTo.hash,
          params: routeTo.params,
          name: "home",
        });
      }

      next();
    },

    children: [
      {
        path: "/",
        name: "home",
        component: () => import("../views/HomeView.vue"),
        beforeEnter(routeTo, routeFrom, next) {
          if (!store.getters["auth/token"]) {
            return next({ name: "login" });
          }
          next();
        },
      },
      {
        path: "api_keys",
        name: "api_keys",
        redirect: "/api-keys",
      },
      {
        path: "api-keys",
        name: "apiKeys",
        component: () => import("../views/ApiKeysView.vue"),
      },
      {
        path: "members",
        name: "members",
        redirect: "/team",
      },
      {
        path: "billing",
        name: "billing",
        component: () => import("../views/BillingView.vue"),
      },
      {
        path: "billing/:id",
        name: "billingDetails",
        component: () => import("../views/BillingDetailsView.vue"),
      },
      {
        path: "team",
        name: "team",
        component: () => import("../views/MembersView.vue"),
      },
      {
        path: "member/:id",
        name: "member",
        component: () => import("../views/UpdateMemberView.vue"),
      },
      {
        path: "dashboard",
        name: "dashboard",
        component: () => import("../views/PortalDashboardView.vue"),
      },
      {
        path: "change-password",
        name: "changePassword",
        component: () => import("../views/ChangePasswordView.vue"),
      },
      {
        path: "documentation",
        name: "documentation",
        component: () => import("../views/DocsView.vue"),
      },
      {
        path: "organizations",
        name: "organizations",
        component: () => import("../views/OrganizationsView.vue"),
      },
      {
        path: "/faq",
        name: "faq",
        component: () => import("../views/FaqView.vue"),
      },
      // {
      //   path: "organization/:id",
      //   name: "organization",
      //   component: () => import("../views/SingleOrganizationView.vue"),
      // },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/portal/",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

export default router;
